import { RouterProvider } from '@tanstack/react-router';
import type { FC } from 'react';
import { Toaster } from '../shared/ui';
import { AppProviders } from './providers';
import { router } from './router';

/**
 * App層 - アプリケーション全体の初期化・統合
 *
 * FSD App層の責務：
 * - グローバルProviders統合
 * - ルーティング設定
 * - グローバルUIコンポーネント（Toast等）
 * - エラーバウンダリー（将来実装）
 */
export const App: FC = () => {
  return (
    <>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
      <Toaster />
    </>
  );
};
